import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Logger from '../../../../../ui-kitchen/src/utils/logger';
import { scrollTo, getBlogData } from '../AmexMarketingUtils/AmexUtils';
import AmexGDAB2BHeader from './AmexGDAB2BHeader';
import AmexGDAB2BHero from './AmexGDAB2BHero';
import AmexGDAB2BFooter from './AmexGDAB2BFooter';
import AmexGDAB2BWhyWeLove from './AmexGDAB2BWhyWeLove';
import AmexGDAB2BMoreDetails from './AmexGDAB2BMoreDetails';
import AmexEventsComponent from '../AmexMarketingUtils/AmexEventsComponent';
import AmexFAQs from '../AmexMarketingUtils/AmexFAQs';
import AmexTerms from '../AmexMarketingUtils/AmexTerms';
import AmexGDAB2BAboutProgram from './AmexGDAB2BAboutProgram';
import AmexGDAB2BTestimonials from './AmexGDAB2BTestimonials';
import AmexHowItWorks from '../AmexMarketingUtils/AmexHowItWorks';
import AmexGDAB2BDinerExperience from './AmexGDAB2BDinerExperience';
import AmexGDAB2BDRestaurantExperience from './AmexGDAB2BRestaurantExperience';
import AmexCarouselEditorial from '../AmexMarketingUtils/AmexCarouselEditorial/AmexCarouselEditorial';
import { GDAB2B_PAGE_NAME } from '../AmexMarketingUtils/constants';
import { updateParsedEventData, fetchJSONExperientialEvents, fetchEventsAndExperientialExt } from '../AmexMarketingUtils/AmexExperientialUtils';
import { selectIsAuthenticated } from '../../../../../ui-kitchen/src/reducers/authTokenSlice';

import './AmexGDAB2B.scss';

class AmexGDAB2B extends React.Component {
  static propTypes = {
    $rootScope: PropTypes.shape({
      $digest: PropTypes.func,
      matchMedia: PropTypes.shape({
        xs: PropTypes.bool,
        sm: PropTypes.bool,
        md: PropTypes.bool,
        lg: PropTypes.bool,
        ipadLandscape: PropTypes.bool,
        xl: PropTypes.bool,
      }),
      locationCode: PropTypes.string,
    }).isRequired,
    ResyAmexConfig: PropTypes.shape({
      baseRequestUrl: PropTypes.string.isRequired,
      gdaEditorialApi: PropTypes.string.isRequired,
    }).isRequired,
    Analytics: PropTypes.shape({
      event: PropTypes.func,
    }).isRequired,
    $location: PropTypes.shape({
      path: PropTypes.func,
      search: PropTypes.func,
    }).isRequired,
    selectedCoreSeats: PropTypes.number.isRequired,
    selectedCoreISODate: PropTypes.string.isRequired,
    selectedCoreTime: PropTypes.string.isRequired,
    locationBySlug: PropTypes.shape({}).isRequired,
    isAuthenticated: PropTypes.bool.isRequired,
  }

  state = {
    contentData: null,
    hash: null,
    videoHasError: false,
    eventsFetchedData: null,
    eventsLoading: true,
    eventComponentStatus: true,
    testimonialsComponentStatus: true,
    restaurantExperienceComponentStatus: true,
    dinerExperienceComponentStatus: true,
    blogDataArray: [],
  };

  componentDidMount = async () => {
    const currentHash = (window.location.hash).replace('#', '');
    window.addEventListener('hashchange', this.handleHashChange, false);
    this.fetchData(currentHash);
  }

  async componentDidUpdate(prevProps, prevState) {
    const { hash, contentData } = this.state;
    if (prevState.hash !== hash) {
      window.location.hash = hash;
      if (hash) {
        scrollTo(`#${hash}`);
      }
    }

    const {
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime,
      locationBySlug,
    } = this.props;

    if (Object.keys(locationBySlug).length > 0
    && (prevProps.selectedCoreSeats !== selectedCoreSeats
      || prevProps.selectedCoreISODate !== selectedCoreISODate
      || prevProps.selectedCoreTime !== selectedCoreTime
      || prevProps.locationBySlug !== locationBySlug
      || prevState.contentData !== contentData)) {
      if (!contentData?.events_and_experiences?.hide_section) {
        const eventsFetchedData = await fetchEventsAndExperientialExt(this.props, contentData?.events_and_experiences, GDAB2B_PAGE_NAME);
        this.updateEventsState(eventsFetchedData);
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('hashchange', this.handleHashChange, false);
  }

  updateEventsState = (eventsFetchedData) => {
    this.setState({ eventsFetchedData, eventsLoading: false });
  }

  fetchData = async (hash) => {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
        gdaEditorialApi,
      },
    } = this.props;

    const dataEndPoint = `${baseRequestUrl}AmexGDAB2B/AmexGDAB2BData.json`;
    try {
      const dataResponse = await fetch(dataEndPoint, {
        method: 'GET',
      });
      const contentData = await dataResponse.json();
      this.setState(
        {
          contentData,
          hash,
        }
      );
      const editorialsData = contentData?.editorials;
      const blogDataArray = await getBlogData(editorialsData, gdaEditorialApi, 'AmexGDAB2B');
      this.setState({ blogDataArray });
    } catch (err) {
      Logger.error('[AmexGDAB2B] AmexGDAB2B JSON File Error :', err);
    }
  }

  updateEventsDataForNotify = async (eventDetails) => {
    const {
      eventsFetchedData,
    } = this.state;

    const {
      experientialEvents,
      experientialEventsConfig,
    } = eventsFetchedData;
    const {
      ResyAmexConfig: {
        baseRequestUrl,
      },
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug,
    } = this.props;

    const propsValue = {
      selectedCoreSeats, selectedCoreISODate, selectedCoreTime, locationBySlug,
    };

    const jsonExperientialEvents = await fetchJSONExperientialEvents(baseRequestUrl);

    this.setState({
      eventsFetchedData: {
        ...eventsFetchedData,
        experientialEvents: updateParsedEventData(
          eventDetails,
          experientialEvents,
          experientialEventsConfig,
          jsonExperientialEvents,
          propsValue
        ),
      },
    });
  }

  handleHashChange = () => {
    const currentLocationHash = (window.location.hash).replace('#', '');
    if (currentLocationHash && currentLocationHash !== '') {
      this.setState({ hash: currentLocationHash });
    }
  }

  handleVideoError = (value) => {
    this.setState({ videoHasError: value });
  }

  getComponentStatus = (compName, status) => {
    this.setState({
      [compName]: status,
    });
  }

  render() {
    const {
      ResyAmexConfig: {
        baseRequestUrl,
        gdaEditorialApi,
      },
      $rootScope: {
        matchMedia,
      },
      $location,
      $rootScope,
      Analytics,
      selectedCoreSeats,
      isAuthenticated,
    } = this.props;

    const {
      contentData,
      hash,
      videoHasError,
      eventsFetchedData,
      eventsLoading,
      eventComponentStatus,
      testimonialsComponentStatus,
      restaurantExperienceComponentStatus,
      dinerExperienceComponentStatus,
      blogDataArray,
    } = this.state;

    if (!contentData) return null;

    const {
      is_page_enabled: isPageEnabled,
    } = contentData;

    if (!isPageEnabled) {
      // 404 error page
      $location.path('/404');
      $rootScope.$digest();
      return null;
    }

    const { hide_section: hideHeroBox } = contentData?.hero_box;
    const { hide_section: hideAbout } = contentData?.about_program;
    const { hide_section: hideHowItWorks } = contentData?.how_it_works;
    const { hide_section: hideWhyWeLove } = contentData?.why_we_love;
    const { hide_section: hideRestaurantExperienceSection } = contentData?.restaurant_experience;
    const { hide_section: hideDinerExperienceSection } = contentData?.diner_experience;
    const { hide_section: hideTestimonialsSection } = contentData?.testimonials;
    const { hide_section: hideFAQs } = contentData?.faqs;
    const { hide_section: hideTerms } = contentData?.terms;
    const { hide_section: hideHungryForDetails } = contentData?.more_details;
    const { hide_section: hideEditorialsSection } = contentData?.editorials;
    const hideEventsAndExperiences = contentData?.events_and_experiences?.hide_section || !eventComponentStatus;
    const hideAboutProgram = hideAbout || videoHasError;
    const hideTestimonials = hideTestimonialsSection || !testimonialsComponentStatus;
    const hideRestaurantExperience = hideRestaurantExperienceSection || !restaurantExperienceComponentStatus;
    const hideDinerExperience = hideDinerExperienceSection || !dinerExperienceComponentStatus;
    const hideEditorials = !contentData?.editorials || hideEditorialsSection || blogDataArray?.length === 0;

    const { showall = '' } = $location.search();
    let showAllEnabled = false;
    if (showall === 'enabled') showAllEnabled = true;

    const eventsAndExperiencesData = {
      ...eventsFetchedData,
      eventsLoading,
      isAuthenticated,
      $rootScope,
      selectedCoreSeats,
      updateParsedEventData: this.updateEventsDataForNotify,
      showAllEnabled,
    };

    const displayMenuItems = {
      aboutprogram: !hideAboutProgram,
      events: !hideEventsAndExperiences,
      editorial: !hideEditorials,
      restaurantexperience: !hideRestaurantExperience,
      dinerexperience: !hideDinerExperience,
      testimonials: !hideTestimonials,
    };

    return (
      <div className="AmexGDAB2B">
        <AmexGDAB2BHeader
          $location={$location}
          $rootScope={$rootScope}
          Analytics={Analytics}
          matchMedia={matchMedia}
          baseRequestUrl={baseRequestUrl}
          contentData={contentData}
          displayMenuItems={displayMenuItems}
        />
        {!hideHeroBox && (
          <AmexGDAB2BHero
            baseRequestUrl={baseRequestUrl}
            contentData={contentData?.hero_box}
          />
        )}
        {!hideAboutProgram && (
          <AmexGDAB2BAboutProgram
            baseRequestUrl={baseRequestUrl}
            aboutConfig={contentData?.about_program}
            Analytics={Analytics}
            matchMedia={matchMedia}
            handleVideoError={this.handleVideoError}
          />
        )}
        {!hideHowItWorks && (
          <AmexHowItWorks
            iconPathPrefix={`${baseRequestUrl}AmexGDAB2B/images/HowProgramWorks/`}
            howItWorksConfig={contentData?.how_it_works}
          />
        )}
        {!hideWhyWeLove && (
          <AmexGDAB2BWhyWeLove
            baseRequestUrl={baseRequestUrl}
            contentData={contentData?.why_we_love}
            matchMedia={matchMedia}
            Analytics={Analytics}
          />
        )}
        {!hideRestaurantExperience && (
          <AmexGDAB2BDRestaurantExperience
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            restaurantExperienceConfig={contentData?.restaurant_experience}
            getRestaurantExperienceComponentStatus={(status) => this.getComponentStatus('restaurantExperienceComponentStatus', status)}
          />
        )}
        {!hideDinerExperience && (
          <AmexGDAB2BDinerExperience
            baseRequestUrl={baseRequestUrl}
            Analytics={Analytics}
            matchMedia={matchMedia}
            dinerExperienceConfig={contentData?.diner_experience}
            getDinerExperienceComponentStatus={(status) => this.getComponentStatus('dinerExperienceComponentStatus', status)}
          />
        )}
        {!hideEditorials && (
          <AmexCarouselEditorial
            editorialsConfig={contentData?.editorials}
            taggingConfig={contentData?.editorials.event_tag}
            blogDataArray={blogDataArray}
            gdaEditorialApi={gdaEditorialApi}
            Analytics={Analytics}
            matchMedia={matchMedia}
          />
        )}
        {!hideEventsAndExperiences && (
          <AmexEventsComponent
            baseRequestUrl={baseRequestUrl}
            contentData={contentData?.events_and_experiences}
            matchMedia={matchMedia}
            Analytics={Analytics}
            eventsAllData={eventsAndExperiencesData}
            getEventComponentStatus={(status) => this.getComponentStatus('eventComponentStatus', status)}
          />
        )}
        {!hideTestimonials && (
          <AmexGDAB2BTestimonials
            baseRequestUrl={baseRequestUrl}
            matchMedia={matchMedia}
            testimonialsData={contentData?.testimonials}
            getTestimonialsComponentStatus={(status) => this.getComponentStatus('testimonialsComponentStatus', status)}
          />
        )}
        {!hideHungryForDetails && (
          <AmexGDAB2BMoreDetails
            baseRequestUrl={baseRequestUrl}
            hungryForDetailsConfig={contentData?.more_details}
            Analytics={Analytics}
            matchMedia={matchMedia}
          />
        )}
        {!hideFAQs && (
          <AmexFAQs
            faqsConfig={contentData?.faqs}
            eventAnalytics={Analytics.event}
          />
        )}
        {!hideTerms && (
          <AmexTerms
            baseRequestUrl={baseRequestUrl}
            hash={hash}
            termsConfig={contentData?.terms}
            Analytics={Analytics}
          />
        )}
        <AmexGDAB2BFooter
          baseRequestUrl={baseRequestUrl}
          footerConfig={contentData?.footer}
          Analytics={Analytics}
          matchMedia={matchMedia}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    bySlug: locationBySlug,
  } = state.resyLocations;

  const {
    selectedCoreISODate, selectedCoreSeats, selectedCoreTime,
  } = state.resyCore;

  return {
    locationBySlug,
    selectedCoreISODate,
    selectedCoreSeats,
    selectedCoreTime,
    isAuthenticated: selectIsAuthenticated(state),
  };
};

AmexGDAB2B.displayName = 'AmexGDAB2B';
export { AmexGDAB2B as ComponentAmexGDAB2BUnderTest, mapStateToProps };
export default connect(mapStateToProps)(AmexGDAB2B);
